import { AuthService } from "src/app/Auth/auth.service";
import { Injectable } from "@angular/core";
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  Route,
  Router
} from "@angular/router";
import { Observable } from "rxjs";
import { resolve } from "url";

@Injectable({
  providedIn: "root"
})
export class AuthGuard implements CanActivate {
  constructor(private as: AuthService, private router: Router) {}
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return new Promise((resolve, reject) => {
      this.as.User.subscribe(user => {
        if (!user) resolve(true);
        else {
          this.router.navigate(["/"]);
        }
      });
    });
  }
}
